import { useState, useEffect } from "react";

import api from "../api/api";

import { sha256 } from 'js-sha256';
import { format } from "date-fns";

const useFetch = () => {
  const [data, setData] = useState({
    slug: "",
    results: {},
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data.slug !== "") {
      const timeoutId = setTimeout(() => {
        const fetch = async () => {
          setIsLoading(true);
          try {
            const res = await api.get(`/lotto/check-stats?q=${data.slug}`, {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': sha256(process.env.REACT_APP_API_KEY + "." + format(new Date(), 'yyyy-MM-dd') + ".get")
              }
            });
            setData((prev) => ({ ...prev, results: res.data }));
          } catch (err) {
            console.error(err);
            setData((prev) => ({ ...prev, results: { statusCode: 500 } }));
          } finally {
            setIsLoading(false);
          }
        };
        fetch();
      }, 600);
      return () => clearTimeout(timeoutId);
    }
  }, [data.slug]);

  return { data, setData, isLoading };
};

export default useFetch;
